
import { createContext, useContext } from "react";

export interface SlideContextValue {
  activeFragment: number;
  isActive: boolean;
  number: number;
}

export const SlideContext = createContext<SlideContextValue>({
  activeFragment: 0,
  isActive: false,
  number: 1,
});

export function useSlideContext(): SlideContextValue {
  return useContext(SlideContext);
}
